import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const RuletaRegister = lazyRouteComponent(() => import('../pages/ruleta-register'))

export const ruletaRegisterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/ruleta-register',
  component: RuletaRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
